import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Table, Button, Modal, Input, Tooltip, Space } from "antd";
import { SearchOutlined } from '@ant-design/icons';
import config from "../../config";
import { FaTrash, FaEdit, FaDev } from "react-icons/fa";
import { RiDeviceRecoverLine } from "react-icons/ri";
import { FiShield } from "react-icons/fi";
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { FaChalkboardTeacher } from "react-icons/fa";
import SelectCourseModal from "../Forms/SelectCourseModal";
import UserRolesModal from "../Roles/UserRolesModal";
import PermissionGuard from "../Guards/PermissionGuard";
import { useAuth } from "../../contexts/AuthContext";
import { PERMISSIONS } from "../../constants/permissions";


axios.defaults.withCredentials = true;

const UsersTable = () => {
    const [users, setUsers] = useState([]);
    const [allUsers, setAllUsers] = useState({});
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const tableWrapperRef = useRef(null);
    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
    const [isRolesModalOpen, setIsRolesModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const { hasPermission } = useAuth();

    const [searchFilters, setSearchFilters] = useState({
        username: "",
        personalId: "",
        lastname: "",
        firstname: "",
        phoneNumber: ""
    });

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
      });

    const handleDelete = (id) => {
        toast.warn(
            <div className="text-right font-custom">
                <p>آیا از حذف این کاربر مطمئن هستید؟</p>
                <div className="flex justify-end gap-2 mt-2">
                    <button
                        className="bg-red-500 hover:bg-red-700 text-white px-3 py-1 rounded"
                        onClick={() => confirmDelete(id)}
                    >
                        حذف
                    </button>
                    <button
                        className="bg-gray-500 hover:bg-gray-700 text-white px-3 py-1 rounded"
                        onClick={() => toast.dismiss()}
                    >
                        انصراف
                    </button>
                </div>
            </div>,
            { autoClose: false, icon: false }
        );
    };
    const clearDeviceId = (id) => {
        toast.warn(
            <div className="text-right font-custom">
                <p>اطلاعات دستگاه کاربر حذف شوند؟</p>
                <div className="flex justify-end gap-2 mt-2">
                    <button
                        className="bg-red-500 hover:bg-red-700 text-white px-3 py-1 rounded"
                        onClick={() => confirmClear(id)}
                    >
                        بله
                    </button>
                    <button
                        className="bg-gray-500 hover:bg-gray-700 text-white px-3 py-1 rounded"
                        onClick={() => toast.dismiss()}
                    >
                        انصراف
                    </button>
                </div>
            </div>,
            { autoClose: false, icon: false }
        );
    };



    const fetchUsersWithFilters = async () => {

        try {
            setLoading(true);

            // Build the dynamic filter string
            let dynamicFilter = `role=0`;  // Always include role=0

            if (searchFilters.username) {
                dynamicFilter += `,username=*${searchFilters.username}/i`;
            }

            if (searchFilters.personalId) {
                dynamicFilter += `,personalId=*${searchFilters.personalId}/i`;
            }
            if (searchFilters.lastname) {
                dynamicFilter += `,lastname=*${searchFilters.lastname}/i`;
            }
            if (searchFilters.firstname) {
                dynamicFilter += `,firstname=*${searchFilters.firstname}/i`;
            }
            if (searchFilters.phoneNumber) {
                dynamicFilter += `,phoneNumber=*${searchFilters.phoneNumber}/i`;
            }
            // Send request with the dynamically constructed filter string
            const response = await axios.get(
                `${config.apiBaseUrl}/api/Users/GetUsersList`,
                {
                    params: {
                        page: 1,
                        pageSize: 10,
                        filter: dynamicFilter,  // Pass the dynamic filter
                    },
                    headers: {
                        "HeaderKey": config.HeaderKey
                    },
                    withCredentials: true,
                }
            );
            setUsers(response.data.users);
        } catch (error) {
            toast.error(<p dir="rtl" className="font-custom">جستجو با خطا مواجه شد</p>);
            if (error.response && error.response.status === 401) {
                navigate("/");
            }
        } finally {
            setLoading(false);
        }
    };

    const confirmDelete = async (id) => {
        try {
            toast.dismiss();
            const response = await axios.post(
                `${config.apiBaseUrl}/api/users/DeleteUser`,
                id,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                        "HeaderKey": config.HeaderKey
                    },
                }
            );

            if (response.status === 200) {
                setUsers(prevUsers => prevUsers.filter(user => user.userID !== id));
                toast.success(<p dir="rtl" className="font-custom">کاربر با موفقیت حذف شد!</p>);
            } else {
                toast.error(<p dir="rtl" className="font-custom">خطا در حذف کاربر!</p>);

            }
        } catch (error) {
            toast.error("خطا در برقراری ارتباط با سرور!", { autoClose: 3000 });
        }
    };
    const confirmClear = async (id) => {
        try {

            toast.dismiss();
            const response = await axios.post(
                `${config.apiBaseUrl}/api/users/ClearDeviceId`,
                id,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                        "HeaderKey": config.HeaderKey
                    },
                }
            );

            if (response.status === 200) {
                toast.success(<p dir="rtl" className="font-custom">اطلاعات دستگاه کاربر حذف شد</p>);

            } else {
                toast.error("خطا در عملیات", { autoClose: 3000 });
            }
        } catch (error) {
            toast.error(<p dir="rtl" className="font-custom">خطا در برقراری ارتباط</p>);

        }
    };

    const fetchUsers = async (page = 1, pageSize = 20) => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${config.apiBaseUrl}/api/Users/GetUsersList`,
                {
                    params: {
                        page,
                        pageSize,
                        filter: `role=0`, // Filter can be dynamic if you need to handle different filters
                    },
                    headers: {
                        "HeaderKey": config.HeaderKey
                    },
                    withCredentials: true,
                }
            );
            setPagination({
                page:page,
                pageSize:pageSize,
                total: response.data.totalCount, // pass total here
              });
              setAllUsers(response.data.users);
              setUsers(response.data.users);  // Assuming the response includes paginated data
        } catch (error) {
            toast.error(<p dir="rtl" className="font-custom">خطا در برقراری ارتباط</p>);
            if (error.response && error.response.status === 401) {
                navigate("/");
            }
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchUsers(1, 20);
    }, []);

    const handleSearchChange = (e, columnName) => {

        
            let value = e.target.value;

            const newFilters = {
                ...searchFilters,
                [columnName]: value
            };


            setSearchFilters(newFilters);



            const filteredData = allUsers.filter(user => {
                return (
                    (!newFilters.username || user.username.toLowerCase().includes(newFilters.username.toLowerCase())) &&
                    (!newFilters.personalId || user.personalId.toLowerCase().includes(newFilters.personalId.toLowerCase())) &&
                    (!newFilters.lastname || user.lastname.toLowerCase().includes(newFilters.lastname.toLowerCase())) &&
                    (!newFilters.firstname || user.firstname.toLowerCase().includes(newFilters.firstname.toLowerCase())) &&
                    (!newFilters.phoneNumber || user.phoneNumber.toLowerCase().includes(newFilters.phoneNumber.toLowerCase()))
                );
            });

            setUsers(filteredData);
        

    };

    const ParseRole = (kind) => {

        if (kind === 1) {
            return "پزشکی"
        } else if (kind === 0) {
            return "نامشخص"
        }else if (kind === 2) {
            return "دندانپزشکی"
        }else if (kind === 3) {
            return "آپارات"
        } 
        else if (kind === 4) {
            return "ادمین کل"
        }else {
            return kind;
        }
        
    }

    const columns = [
        {
            title: "عملیات",
            key: "actions",
            fixed: "left",
            width: 20,
            align: "center",
            className: "font-custom text-center",
            render: (row) => (
                <div className="flex gap-2 justify-center">
                    <PermissionGuard permission={PERMISSIONS.USERS_DELETE}>
                        <Button
                            type="link"
                            className="text-red-500"
                            onClick={() => handleDelete(row.userID)}
                            icon={<FaTrash color="#980000" />}
                        />
                    </PermissionGuard>

                    <PermissionGuard permission={PERMISSIONS.USERS_EDIT}>
                        <Button
                            type="link"
                            className="text-blue-500"
                            onClick={() => navigate("/dashboard/users/updateuser", { state: { user: row } })}
                            icon={<FaEdit />}
                        />
                    </PermissionGuard>

                    <PermissionGuard permission={PERMISSIONS.USERS_EDIT}>
                        <Tooltip title="حذف اطلاعات دستگاه">
                            <Button
                                type="link"
                                className="text-green-500"
                                onClick={() => {
                                    clearDeviceId(row.userID);
                                }}
                                icon={<RiDeviceRecoverLine color="#b49002" />}

                            />
                        </Tooltip>
                    </PermissionGuard>

                    <PermissionGuard permission={PERMISSIONS.USERS_EDIT}>
                        <Tooltip title="انتخاب دوره">
                            <Button
                                type="link"
                                className="text-green-500"
                                onClick={() => {
                                    setSelectedUser(row);
                                    setIsUpdateModalOpen(true);
                                }}
                                icon={<FaChalkboardTeacher color="#3aff00" />}

                            />
                        </Tooltip>
                    </PermissionGuard>

                    <PermissionGuard permission={PERMISSIONS.ROLES_ASSIGN}>
                        <Tooltip title="مدیریت نقش‌ها">
                            <Button
                                type="link"
                                className="text-purple-500"
                                onClick={() => {
                                    setSelectedUser(row);
                                    setIsRolesModalOpen(true);
                                }}
                                icon={<FiShield color="#9333ea" />}
                            />
                        </Tooltip>
                    </PermissionGuard>
                </div>
            ),
        },
        {
            title: "نام کاربری",
            dataIndex: "username",
            key: "username",
            width: 20,
            align: "right",
            className: "font-custom text-center",
            filterDropdown: () => (
                <div style={{ padding: 8 }} className="font-custom">
                    <Space.Compact style={{ width: '100%' }}>
                        <Input
                            placeholder="جستجوی نام کاربری"
                            allowClear
                            className="font-custom"
                            onClear={() => {
                                // Reset the search filter and re-fetch data
                                setSearchFilters((prevState) => ({
                                    ...prevState,
                                    username: "",
                                }));
                            }}                    
                            value={searchFilters.username}
                            onChange={(e) => {
                                handleSearchChange(e, "username");
                            }}
                            onPressEnter={() => {
                                fetchUsersWithFilters();
                            }}
                        />
                        <Button type="primary"
                            icon={<SearchOutlined />}
                            onClick={() => {
                                // Server-side search when button is clicked
                                fetchUsersWithFilters();
                            }}
                        />
                    </Space.Compact>
                </div>
            ),
            onFilter: (value, record) => record.username.toLowerCase().includes(value.toLowerCase()),
        },
        {
            title: "شماره تلفن",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
            width: 40,
            align: "center",
            className: "font-custom text-center",
            filterDropdown: () => (
                <div style={{ padding: 8 }}>

                    <Space.Compact style={{ width: '100%' }}>
                        <Input
                            placeholder="جستجوی شماره تلفن"
                            allowClear
                            onClear={() => {
                                // Reset the search filter and re-fetch data
                                setSearchFilters((prevState) => ({
                                    ...prevState,
                                    personalId: "",
                                }));
                            }}
                            value={searchFilters.phoneNumber}
                            onChange={(e) => {
                                handleSearchChange(e, "phoneNumber");
                            }}
                            onPressEnter={() => {
                                fetchUsersWithFilters();
                            }}
                        />
                        <Button type="primary"
                            icon={<SearchOutlined />}
                            onClick={() => {
                                // Server-side search when button is clicked
                                fetchUsersWithFilters();
                            }}
                        />
                    </Space.Compact>
                </div>
            ),
            onFilter: (value, record) => record.personalId.toLowerCase().includes(value.toLowerCase()),
        },
        {
            title: "نوع کاربر",
            dataIndex: "kind",
            key: "kind",
            width: 20,
            align: "center",
            className: "font-custom text-center",
            render: ParseRole,
        },
        {
            title: "کد ملی",
            dataIndex: "personalId",
            key: "personalId",
            width: 40,
            align: "right",
            className: "font-custom text-center",
            filterDropdown: () => (
                <div style={{ padding: 8 }}>

                    <Space.Compact style={{ width: '100%' }}>
                        <Input
                            placeholder="جستجوی کد ملی"
                            allowClear
                            onClear={() => {
                                // Reset the search filter and re-fetch data
                                setSearchFilters((prevState) => ({
                                    ...prevState,
                                    personalId: "",
                                }));
                            }}                    
                            value={searchFilters.personalId}
                            onChange={(e) => {
                                handleSearchChange(e, "personalId");
                            }}
                            onPressEnter={() => {
                                fetchUsersWithFilters();
                            }}
                        />
                        <Button type="primary"
                            icon={<SearchOutlined />}
                            onClick={() => {
                                // Server-side search when button is clicked
                                fetchUsersWithFilters();
                            }}
                        />
                    </Space.Compact>
                </div>
            ),
            onFilter: (value, record) => record.personalId.toLowerCase().includes(value.toLowerCase()),
        },
        {
            title: "نام خانوادگی",
            dataIndex: "lastname",
            key: "lastname",
            width: 40,
            align: "right",
            className: "font-custom text-center",
            filterDropdown: () => (
                <div style={{ padding: 8 }} className="font-custom">
                    <Space.Compact style={{ width: '100%' }}>
                        <Input
                            className="font-custom"
                            placeholder="جستجوی نام خانوادگی"
                            allowClear
                            onClear={() => {
                                // Reset the search filter and re-fetch data
                                setSearchFilters((prevState) => ({
                                    ...prevState,
                                    lastname: "",
                                }));
                            }}                    
                            value={searchFilters.lastname}
                            onChange={(e) => {
                                handleSearchChange(e, "lastname");
                            }}
                            onPressEnter={() => {
                                fetchUsersWithFilters();
                            }}
                        />
                        <Button type="primary"
                            icon={<SearchOutlined />}
                            onClick={() => {
                                // Server-side search when button is clicked
                                fetchUsersWithFilters();
                            }}
                        />
                    </Space.Compact>
                </div>
            ),
            onFilter: (value, record) => record.lastname.toLowerCase().includes(value.toLowerCase()),
        },
        {
            title: "نام",
            dataIndex: "firstname",
            key: "firstname",
            width: 30,
            align: "right",
            className: "font-custom text-center",
            filterDropdown: () => (

                <div style={{ padding: 8 }}>
                    <Space.Compact style={{ width: '100%' }}>
                        <Input
                            className="font-custom"
                            placeholder="جستجوی نام"
                            allowClear
                            onClear={() => {
                                // Reset the search filter and re-fetch data
                                setSearchFilters((prevState) => ({
                                    ...prevState,
                                    firstname: "",
                                }));
                            }}                    
                            value={searchFilters.firstname}
                            onChange={(e) => {
                                handleSearchChange(e, "firstname");
                            }}
                            onPressEnter={() => {
                                fetchUsersWithFilters();
                            }}
                        />
                        <Button type="primary"
                            icon={<SearchOutlined />}
                            onClick={() => {
                                // Server-side search when button is clicked
                                fetchUsersWithFilters();
                            }}
                        />
                    </Space.Compact>
                </div>
            ),
            onFilter: (value, record) => record.firstname.toLowerCase().includes(value.toLowerCase()),
        },
    ];



    return (
        <div className="font-custom rtl text-right p-5">
            <h1 className="text-center text-xl mt-5 mb-5">لیست کاربران سامانه</h1>
            
            <PermissionGuard permission={PERMISSIONS.USERS_CREATE}>
                <button className="bg-green-700 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-full shadow-md transition duration-300 mb-5" onClick={() => navigate("adduser")}>
                    + جدید
                </button>
            </PermissionGuard>

            <div ref={tableWrapperRef} className="overflow-x-auto">
                <Table
                    columns={columns}
                    dataSource={users}
                    loading={loading}
                    rowKey={(record) => record.userID}
                    scroll={{ x: 1000 }}
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: pagination.total,
                        onChange: (page, pageSize) => {
                            setPagination((prev) => ({
                                ...prev,
                                current: page,
                                pageSize: pageSize,
                            }));
                          fetchUsers(page, pageSize);
                        },
                    }}
                />
                <Modal
                    open={isUpdateModalOpen}
                    onCancel={() => setIsUpdateModalOpen(false)}
                    footer={null}
                    centered
                    width={1000}
                    destroyOnClose 
                >
                    <SelectCourseModal
                        object={selectedUser}
                        onSuccess={() => {
                            setIsUpdateModalOpen(false);
                            fetchUsers(); // refresh users after update
                        }}
                        type="user"
                    />
                </Modal>

                <UserRolesModal
                    visible={isRolesModalOpen}
                    user={selectedUser}
                    onClose={() => setIsRolesModalOpen(false)}
                    onSuccess={() => {
                        fetchUsers(); // refresh users after role update
                    }}
                />
            </div>
            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                rtl
                theme="dark"
                transition={Bounce}
            />
        </div>
    );
};

export default UsersTable;